module.exports = __webpack_public_path__ + "static/media/check.7f268ca9.svg";